import React, { useCallback, useEffect, useState,useRef,use } from "react";
import { Card, Pagination, Button, ConfigProvider, Input, message ,Modal,Select,DatePicker,Form,Row,Col,Radio,Cascader} from "antd";
import { useHistory } from "react-router-dom";
import "./index.scss";
import { JobItem, CustomModal } from "./components";
import Nav from "components/Nav";
import { navRouter } from "../fieldConfig";
import { jobData, formConfig } from "./fieldConfig";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http";
import zh_CN from "antd/es/locale/zh_CN";
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import moment from 'moment'
import {getCitys } from 'utils/storage';
import {getStatus} from '@/utils/methods';
import ApproveModal from '@/components/ApproveModal'
import { set } from "mobx";

const { Search } = Input;
const FormItem = Form.Item
const Option = Select.Option
const { TextArea } = Input;

function itemRender(current, type, originalElement) {
  if (type === "prev") {
    return <a>上一页</a>;
  }
  if (type === "next") {
    return <a>下一页</a>;
  }
  return originalElement;
}

export default function JobPublish(props) {
  const [data, setData] = useState([]);
  const [listId, setListId] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [deleteconfirmLoading, setDeleteconfirmLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [useInterface,setUseInterface]=useState('');
  const [formData, setFormData] = useState(formConfig());
  const [listData, setListData] = useState([]);
  const [listSoure, setlistSoure] = useState({});
  const [detailInfo, setDetailInfo] = useState({});
  const [cityStr, setCityStr] = useState('')
  const citys = getCitys()
  const modalRef = useRef([])
  const [visible,setVisible] = useState(false)
  const [confirmLoading,setConfirmLoading] = useState(false)
  const [form] = Form.useForm();
  let timer = null;
  const handlePage = useCallback((page, pageSize) => {
    setCurrentPage(page);
    // console.log('page, pageSizepage, pageSize',);
    
    getListInfo({page, pageSize})
  }, []);

  const history = useHistory();

  const handleFormChange = useCallback((name, value) => {
    const newFormData = formData.map((item) => {
      if (item.name == name) {
        item.value = value;
        return { ...item, [name]: value };
      }
      return { ...item };
    });
    setFormData([...newFormData]);
    // console.log("newFormData", newFormData);
  }, []);

  const handleOk = useCallback((e) => {
    // console.log("useuser",useInterface);
    let arrList = {};
    formData.map((item) => {
      let obj = {};
      obj[item.name] = item.value;
      arrList = { ...arrList, ...obj };
      obj = {};
    });
    let parms = JSON.parse(JSON.stringify(arrList));
    if(useInterface==''){
    //新增
    Http.postJson(Request.publishNewJob(), { ...JSON.parse(JSON.stringify(parms)) }, (obj) => {
      if (obj.code == 200) {
        // console.log(obj);
        message.success("职位发布成功");
        setShowModal(false);
        getListInfo();
      } else {
        message.error(`${obj.msg}`);
      }
    });
  }else{
    let arrList = {};
    formData.map((item) => {
      let obj = {};
      obj[item.name] = item.value;
      arrList = { id:useInterface,jobInformationState:0,jobInformationReason:'',...arrList, ...obj };
      obj = {};
    });
    // console.log("arrlisarrListarrListarrListarrListarrListt",arrList);
    parms=JSON.parse(JSON.stringify(arrList));
    //编辑
    Http.postJson(Request.updateJob(),{...parms},(obj)=>{
      if(obj.code==200){
        message.success("职位编辑成功");
        setShowModal(false);
        getListInfo();
      }else{
        message.error(`${obj.msg}`);
      }
    })
    // console.log("parmsparmsparmsparmsparms",parms);

  }

  });

  const handleCancel = useCallback((e) => {
    setOpen(false)
    setShowModal(false);
  });

  const handlePublish = useCallback(() => {
    // getStatus().then(res=>{
    // if(res===false){
    //   modalRef.current.showModal();
    //   return;
    // }
    // setShowModal(true);
    // setUseInterface('');
    // })
    // console.log('111111111111111111111111111111');
    
    setVisible(true)
    form.setFieldsValue({})
    setDetailInfo({})
    setCityStr('')
  }, []);

  const handleJobDetail = useCallback((e, id) => {
    e.persist();
    history.push(`/entrance/recruitEnterprise/jobPublish/jobDetail/${id}`);
  }, []);

  const handleOpenOrClose = useCallback((data, e, id) => {
    // console.log(id, data);
    e.stopPropagation();
    if (!data) {
      Http.getApplication(Request.getJobClose(), { id: id }, (obj) => {
        if (obj.code == 200) {
          message.success("职位关闭成功");
          getListInfo();
        } else {
          message.error(`${obj.msg}`);
        }
      });
    } else {
      Http.getApplication(Request.getJobOpen(), { id: id }, (obj) => {
        if (obj.code == 200) {
            message.success("职位开启成功");
            getListInfo();
        } else {
          message.error(`${obj.msg}`);
          getListInfo();
        }
      });
    }
  }, []);

  const handleEdit = useCallback((e, id) => {
    e.stopPropagation();
    Http.getApplication(Request.getJobDetail(), { id: id }, (obj) => {
      // console.log(obj);
      if (obj.code == 200) {
        setFormData(formConfig(obj.data));
        setDetailInfo(obj.data)
        // console.log('obj.data.recordsobj.data.records',obj.data);
        if(obj.data.deadline){
          obj.data.deadline = moment(obj.data.deadline)
        }
        if(obj.data.jobReleaseTime){
          obj.data.jobReleaseTime = moment(obj.data.jobReleaseTime)
        }
        form.setFieldsValue(obj.data)
      } else {
        message.error(`${obj.msg}`);
      }
    });
    setShowModal(true);
    setVisible(true)
    setUseInterface(id);
  }, []);

  const handleDel = useCallback((e, id) => {
    setListId(id)
    setOpen(true);
    e.stopPropagation();
    
  }, []);
  const handleDelete = useCallback(()=>{
    Http.get(Request.deliteJob(), { ids: [listId] }, (obj) => {
      if (obj.code == 200) {
        getListInfo();
        message.success("删除成功");
        setOpen(false)
      } else {
        message.error(`${obj.msg}`);
      }
    });
  })
  // const handleDeleteOk = () => {
  //   setConfirmLoading(true);
  //   setTimeout(() => {
  //     setOpen(false);
  //     setConfirmLoading(false);
  //   }, 2000);
  // };
  useEffect(() => {
    setData(jobData);
    setTotal(500);
  }, [currentPage]);
  //获取列表数据
  useEffect(() => {
    getListInfo();
  }, []);
  const getListInfo = useCallback((paramsInfo) => {
    // console.log('paramsInfoparamsInfo',paramsInfo);
    
    let params = {
      descs:"create_time",
      size: 10,
      current: paramsInfo && paramsInfo.page ?paramsInfo.page: 1,
      // userId:'1535195334123196419'
    };
    Http.get(Request.getJobList(), { ...params }, (obj) => {
      if (obj.code == 200) {
        // console.log(obj);
        setListData(obj.data.records);
        setlistSoure(obj.data);
        
      } else {
        message.error(`${obj.msg}`);
      }
    });
  });



  const handleOkTwo = () => {
    // setModalText('The modal will be closed after two seconds');
    form.validateFields().then((values) => {
      setConfirmLoading(true);

      // console.log('valuesvaluesvaluesvalues',values,detailInfo);
      console.log('valuesvaluesvaluesvalues',values);
      
      if(values.salaryMin&&values.salaryMax){
        values.salary = values.salaryMin + '~' + values.salaryMax
      }
      
      if(values.deadline){
        values.deadline = moment(values.deadline).format('YYYY-MM-DD')
      }
      if(values.jobReleaseTime){
        values.jobReleaseTime = moment(values.jobReleaseTime).format('YYYY-MM-DD')
      }else{
        values.jobReleaseTime = moment(moment()).format('YYYY-MM-DD')
      }
      if(cityStr){
        values.workArea = cityStr
      }

      if(detailInfo.id){
        values.id = detailInfo.id
        // return
        Http.postJson(Request.updateJob(),{...values},(obj)=>{
          if(obj.code==200){
            message.success("职位编辑成功");
            setVisible(false);
            setConfirmLoading(false);
            getListInfo();
          }else{
            message.error(`${obj.msg}`);
            setConfirmLoading(false);
          }
        })
    }else{
      Http.postJson(Request.publishNewJob(), { ...values }, (obj) => {
        if (obj.code == 200) {
          // console.log(obj);
          message.success("职位发布成功");
          setVisible(false);
          setConfirmLoading(false);
          getListInfo();

        } else {
          message.error(`${obj.msg}`);
          setConfirmLoading(false);
        }
      });
      
    }
     
    })
    .catch((error) => {
      // console.log('555555555555555555555');
      message.error('请输入必填信息')
      // message.error(error);
    });
    // setTimeout(() => {
      
    //   setVisible(false);
    //   setConfirmLoading(false);
    // }, 2000);
  };

  const handleCancelTwo = () => {
    // console.log('Clicked cancel button');
    setVisible(false);
    setCityStr('')
  };
  const onChangeCity = (value,selectedOptions) =>{
    // console.log('selectedOptions',value,selectedOptions);
    
    let str = ''
    selectedOptions.map((item,index)=>{
      if(index!=selectedOptions.length-1){
        return str = `${str}${item.label}-`
      }else{
        return str = `${str}${item.label}`
      }
    })
    // console.log('strstr',str);
    setCityStr(str)
  }
  const renderFrom = useCallback(()=>{
    const fromList = formConfig ()
    // console.log('renderFrom',fromList);
    const formItemLayout= {
      labelCol: {
        xs: 6,
        md: 6,
        lg: 6,
      },
      wrapperCol: {
        span: 16,
      },
    }
    const formItemLayoutTextEare= {
      labelCol: {
        xs: 3,
        md: 3,
        lg: 3,
      },
      wrapperCol: {
        span: 16,
      },
    }
    return fromList.map((item,index)=>{
      
        if(item.type == 'text'){
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
               key={index}
              //  required={item.required || false}
               rules={[
                {
                  required: item.required || false,
                  message:`请输入${item.label}`
                },
                {
                  pattern:item.pattern || '',
                  message:`请输入正确的${item.label}`
                },
                {
                  max:50,
                  message:'输入限制范围为50'
                }
               ]}
               name={item.name}
               label={item.label}
              //  extra={`请输入${item.label}`}
               >
                 <Input placeholder={`请输入${item.label}`}></Input>
              </FormItem>
            </Col>
          )
        }else if(item.type == 'number'){
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
               key={index}
               rules={[
                {
                  required: item.required || false,
                  message:`请输入${item.label}`
                }
               ]}
               name={item.name}
               label={item.label}
              //  extra={`请输入${item.label}`}
               >
                 <Input type="number" placeholder={`请输入${item.label}`}></Input>
              </FormItem>
            </Col>
          )
        }else if(item.type == 'select'){
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
               key={index}
               rules={[
                {
                  required: item.required || false,
                  message:`请选择${item.label}`
                }
               ]}
               name={item.name}
               label={item.label}
               
               >
                 <Select>
                 {
                 item.options && item.options.map((item,index)=>{
                    return <Option key={index} value = {item.value}>{item.label}</Option>
                 })
                 }
                 </Select>
              </FormItem>
            </Col>
          )
        }else if(item.type == 'textarea'){
          return(
            <Col span = {24}>
            <FormItem
            {...formItemLayoutTextEare}
             key={index}
             required={item.required || false}
             name={item.name}
             label={item.label}
             rules={[
               {
                 max:500,
                 message:'输入限制范围为500'
               }
             ]}
             >
               <TextArea placeholder={`请输入${item.label}`}></TextArea>
            </FormItem>
          </Col>
        )
        }else if(item.type == 'time'){
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
              key={index}
              required={item.required || false}
              name={item.name}
              label={item.label}
              
              >
                <DatePicker  defaultValue={item.disabled ? moment(moment()) : ''}  disabled={item.disabled || false} style={{width:'100%'}} format={'YYYY-MM-DD'} locale={zh_CN}/>
              </FormItem>
            </Col>
          )
          
        }else if(item.type == 'radio'){
      // console.log('itemitemitemitem',form,detailInfo,item);
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
              key={index}
              required={item.required || false}
              name={item.name}
              label={item.label}
              >
                <Radio.Group defaultValue={3} >
                  {
                    item.options && item.options.map((childrenItem,index)=>{
                      return<Radio key={index} value= {childrenItem.value}>{childrenItem.label}</Radio>
                    })
                  }
                </Radio.Group>
              </FormItem>
            </Col>
          )
          
        }else if(item.type == 'Cascader'){
          return(
            <Col span = {12}>
              <FormItem
              {...formItemLayout}
               key={index}
               rules={[
                {
                  required: item.required || false,
                  message:`请选择${item.label}`
                }
               ]}
               name={item.name}
               label={item.label}
               
               >
                 <Cascader
                  placeholder="请选择地区"
                  allowClear={false}
                  options={citys}
                  onChange={onChangeCity}
                />
              </FormItem>
            </Col>
          )
        }
    })
    
  },[visible])
  return (
    <div className="job_publish_container">
      <div className="left_nav">
        <Nav defaultActive={"2"} history={history} dataList={navRouter} />
      </div>
      <div className="job_publish">
        <div className="publish_btn" onClick={handlePublish}>
          <span>发布新职位</span>
        </div>
        {listData && listData.length
          ? listData.map((item, index) => {
              return (
                <JobItem
                  job={item}
                  key={index}
                  handleJobDetail={handleJobDetail}
                  handleOpenOrClose={handleOpenOrClose}
                  handleEdit={handleEdit}
                  handleDel={handleDel}
                />
              );
            })
          : ""}
        <Modal
          title="提示"
          visible={open}
          open={open}
          onOk={handleDelete}
          confirmLoading={deleteconfirmLoading}
          onCancel={handleCancel}
        >
          <p>{"确定要删除吗"}</p>
        </Modal>
        <Pagination
          total={listSoure.total}
          itemRender={itemRender}
          showQuickJumper={{
            goButton: <Button className={"pagination_jump"}>确定</Button>,
          }}
          showTotal={(total) => `共 ${total} 条`}
          onChange={handlePage}
          showSizeChanger={false}
          current={currentPage}
          className="pagination"
        />
      </div>
      {/* {showModal && (
        <CustomModal 
          data={formData}
          onChange={handleFormChange}
          onOk={handleOk}
          onCancel={handleCancel}
        />
      )} */}
      <Modal
        title="职位编辑"
        visible={visible}
        onOk={handleOkTwo}
        confirmLoading={confirmLoading}
        onCancel={handleCancelTwo}
        width={1000}
        destroyOnClose
      >
        <Form
        layout="horizontal"
        form={form}
        // scrollToFirstError
        // className="form_box"
        colon={false}
        preserve={false}
      >
        <Row gutter={24}>
          {renderFrom()}
        </Row>
      </Form>
      </Modal>
      <ApproveModal ref = {modalRef}/>
    </div>
  );
}
